import { IPaginatedApiResponse } from '@/Interfaces/ApiResponse/PaginatedApiResponse.interface';
import { IChangeLogHistoryResponseItem } from '@/Interfaces/ChangeLogHistory.interface';
import { getControlOptionsValues } from '@/helpers/filters/filterMapping';
import { getSortFilter } from '@/helpers/grid/getSortFilter';
import { RootState } from '@/store';
import { SearchChangeLogHistoryFilters } from '@/types/changeLogHistory.types';

export const transformChangeLogHistoryFilters = (filters: SearchChangeLogHistoryFilters) => {
  const { startDate, endDate, whitelabels, clients, advertisers, campaigns, sort, ...payload } = filters;

  return {
    ...payload,
    start_date: startDate,
    end_date: endDate,
    sort: getSortFilter(sort),
    whitelabel_ids: getControlOptionsValues(whitelabels),
    client_ids: getControlOptionsValues(clients),
    advertiser_ids: getControlOptionsValues(advertisers),
    campaign_ids: getControlOptionsValues(campaigns),
  };
};

export const formatChangeLogHistoryResponseData = ({
  data,
  meta,
}: IPaginatedApiResponse<IChangeLogHistoryResponseItem[]>): Pick<RootState['changeLogHistory'], 'data' | 'total'> => {
  return {
    data: data.map(logData => ({
      id: logData.id,
      summary: logData.summary,
      createdAt: logData.created_at,
      advertiserId: logData.advertiser?.id,
      advertiserName: logData.advertiser?.name,
      campaignId: logData.campaign?.id ?? null,
      campaignName: logData.campaign?.name ?? null,
      lineItemId: logData.lineItem?.id ?? null,
      lineItemName: logData.lineItem?.name ?? null,
      userName: logData.user?.fullName,
      userEmail: logData.user?.email,
      userId: logData.user?.id,
      hasChanges: logData.hasChanges ?? false,
      changesCount: logData.changesCount ?? 0,
    })),
    total: meta.total,
  };
};
